module.exports = __webpack_public_path__ + "static/img/aboutplatform_pic.64aada2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutplatform_pic.png
// module id = YPNi
// module chunks = 1